export const SUPPLIERRFQ = "SUPPLIERRFQ";
export const SUPPLIERRFQTOTAL = "SUPPLIERRFQTOTAL";
